(() => {

  const CSS_URL = document.currentScript.dataset.css;
  
  /**
   * @param {HTMLElement} plugin The ChannelTalk plugin element.
   */
  function injectChannelStyles(shadowRoot) {
    if (shadowRoot.querySelector('link[data-vendor-channel-talk]')) return;
  
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = CSS_URL;
    link.dataset.vendorChannelTalk = "";

    shadowRoot.appendChild(link);
  }
  
  /**
   * @param {HTMLElement} plugin The ChannelTalk plugin element.
   */
  function applyChannelTheme(plugin) {
    plugin.style.setProperty(
      "z-index",
      "var(--vendor-widget-z-index)",
      "important"
    );
  }

  /**
   * Waits until the ChannelTalk plugin element has been added to the DOM.
   *
   * @returns {Promise<HTMLElement>} Resolves with the `#ch-plugin` element.
   */
  function waitForPlugin() {
    const existing = document.getElementById("ch-plugin");
    if (existing) {
      return Promise.resolve(existing);
    }

    return new Promise(resolve => {
      const observer = new MutationObserver(mutations => {
        for (const mutation of mutations) {
          if (mutation.type !== "childList") continue;

          for (const node of mutation.addedNodes) {
            if (!(node instanceof HTMLElement)) continue;
            if (node.id !== "ch-plugin") continue;

            observer.disconnect();
            resolve(node);
            return;
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  }

  /**
   * Waits until ChannelTalk has initialized the plugin's inline styles.
   *
   * @param {HTMLElement} plugin The ChannelTalk plugin element.
   * @returns {Promise<void>}
   */
  function waitForPluginZIndex(plugin) {
    const initialized = () =>
      plugin.style.getPropertyValue("z-index") !== "";

    if(!initialized()) {
      return Promise.resolve();
    }

    return new Promise(resolve => {
      const observer = new MutationObserver((mutationList, observer) => {
        for (const mutation of mutationList) {
          if (!initialized()) continue;
          observer.disconnect();
          resolve();
          return;
        }
      });

      observer.observe(plugin, {
        attributes: true,
        attributeFilter: ["style"],
      });
    });
  }

  /**
   * Waits until ChannelTalk has initialized the plugin's shadow host node.
   *
   * @param {HTMLElement} plugin The ChannelTalk plugin element.
   * @returns {Promise<HTMLElement>}
   */
  function waitForPluginShadowRoot(plugin) {

    const getShadowRoot = () => plugin.querySelector('#ch-plugin-entry > div')?.shadowRoot;

    const shadowRoot = getShadowRoot();
    if(shadowRoot) {
      return Promise.resolve(shadowRoot);
    }

    return new Promise(resolve => {
      const observer = new MutationObserver((mutationList, observer) => {
        for (const mutation of mutationList) {
          if (mutation.type !== "childList") continue;

          const shadowRoot = getShadowRoot();
          if(!shadowRoot) continue;

          observer.disconnect();
          resolve(shadowRoot);
          return;
        }
      });

      observer.observe(plugin, {
        childList: true,
        subtree: true,
      });
    });
  }

  
  /**
   * @param {HTMLElement} plugin The ChannelTalk plugin element.
   */
  async function initializeZIndex(plugin) {
    await waitForPluginZIndex(plugin);
    applyChannelTheme(plugin);
  }
  
  /**
   * @param {HTMLElement} plugin The ChannelTalk plugin element.
   */
  async function initializeShadowRoot(plugin) {
    console.log('initializeShadowRoot');
    const shadowRoot = await waitForPluginShadowRoot(plugin);
    injectChannelStyles(shadowRoot);
  }

  async function main() {
    const plugin = await waitForPlugin();
    applyChannelTheme(plugin);

    await Promise.all([
      initializeZIndex(plugin),
      initializeShadowRoot(plugin),
    ]);
  }

  main().catch(error => {
    console.error("ChannelTalk customization failed:", error);
  });

})();